<mat-list class="template-summary__list" data-testid="template-summary" [ngClass]="{'template-summary__list-mobile': isMobile}">
  <mat-list-item class="template-summary__list-item"
    [ngClass]="{'template-summary__remove-hover-effect': isDisabled}"
    [disableRipple]="isDisabled"
    (click)="summaryClicked()"
    (keydown.enter)="$event.target === $event.currentTarget && (summaryClicked())">
    <img matListItemAvatar
      alt="Template Image"
      class="template-summary__image"
      [ngClass]="{'template-summary__image-border': isRoundedBorder}"
      src="{{imageURL}}"/>
    <h4 matListItemTitle class="template-summary__summary-header" [attr.data-testid]="templateName + 'template'">
      {{templateName}}
    </h4>
    @if (type !== rewardType) {
      <span matListItemLine class="template-summary__summary-message">
        <span [innerHTML]="details"></span>
      </span>
    }
    @if (!isDisabled) {
      <button mat-icon-button matListItemMeta data-testid="template-right-icon-button">
        <img alt="Chevron Icon"
          class="template-summary__chevron-icon"
          src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png">
        </button>
      }
    </mat-list-item>
  </mat-list>
